"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorSummary = ErrorSummary;

var _react = _interopRequireWildcard(require("react"));

var _errorSummary = _interopRequireDefault(require("govuk-frontend/govuk/components/error-summary/error-summary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ErrorSummary(props) {
  var className = props.className,
      descriptionChildren = props.descriptionChildren,
      errorList = props.errorList,
      titleChildren = props.titleChildren,
      attributes = _objectWithoutProperties(props, ["className", "descriptionChildren", "errorList", "titleChildren"]);

  var errorSummaryRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    new _errorSummary["default"](errorSummaryRef.current).init();
  }, [errorSummaryRef]);
  (0, _react.useEffect)(function () {
    errorSummaryRef.current.focus();
  }, [errorList]);
  var description;

  if (descriptionChildren) {
    description = /*#__PURE__*/_react["default"].createElement("p", null, descriptionChildren);
  }

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "govuk-error-summary ".concat(className || ''),
    "aria-labelledby": "error-summary-title",
    role: "alert",
    tabIndex: "-1"
  }, attributes, {
    "data-module": "govuk-error-summary",
    ref: errorSummaryRef
  }), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "govuk-error-summary__title",
    id: "error-summary-title"
  }, titleChildren), /*#__PURE__*/_react["default"].createElement("div", {
    className: "govuk-error-summary__body"
  }, description, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "govuk-list govuk-error-summary__list"
  }, errorList.map(function (error, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: error.reactListKey || index
    }, error.href ? /*#__PURE__*/_react["default"].createElement("a", error, error.children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, error.children));
  }))));
}

ErrorSummary.defaultProps = {
  titleChildren: 'There is a problem'
};